import XEUtils from 'xe-utils'
import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import httpManager from '../../util/common'
import {mapGetters} from "vuex";
Vue.use('vxe-utils');
Vue.use('vxe-table');
let vm = {
  delimiters: ['{', '}'],
  props: {},
  data: () => {

    return {
      data: null,
      type:"",
      dateRange: null,
    }
  },
  methods: {
PrefixInteger(num, n) {
    return (Array(n).join(0) + num).slice(-n);
},
    getESGData() {
      let self = this
      let type = self.type
      self.loading = true
      let date = new Date()
      date = new Date(date.setDate(date.getDate() - 1))
      let yearN = date.getFullYear().toString()
      let monthN = (date.getMonth() + 1).toString()
      if (monthN < 10) monthN = "0" + monthN
      let dateN = self.PrefixInteger(date.getDate(), 2).toString()
      let end = yearN + "." + monthN + "." + dateN
      let dateB7 = new Date(date.setDate(date.getDate() - 6))
      let yearB = dateB7.getFullYear().toString()
      let monthB = (dateB7.getMonth() + 1).toString()
      if (monthB < 10) monthB = "0" + monthB
      let dateB = self.PrefixInteger(dateB7.getDate(), 2).toString()
      let start = yearB + "." + monthB + "." + dateB
      self.dateRange=start+"-"+end
      let params = new Map()
      // params.set("type", year)
      httpManager("esg_event_count_list", params)
        .then(response => {
          self.data = response.data.data
          self.loading = false
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },

    cellClickEvent({row, column}) {
      const {
        href
      } = this.$router.resolve({path:  '/entity/'+row.oa_id+'/home'})
      window.open(href, '_blank')

    }
  },
  mounted() {
    this.getESGData()
  },

  watch: {
    type: function () {
      this.getESGData()
    }
  },
  computed: {
    tableColumn() {
      return [
        {title: this.$t('common.company_name'), field: "full_name",width:'60%'},
        {title: this.$t('esg.latest_esg_rating'), field: "rating",width:'28%'},
        {title: this.$t('esg.heat'), field: "num",width:'12%'},
      ]
    }
  }
}
Vue.component("esg-event-count-list", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_event_count_list.js